var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityTypeConfigurationHelper } from '../models/basics/basics.models';
import { autoinject } from "aurelia-dependency-injection";
import { BaseQueryWidgetConfiguration } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import { DataType } from '../models/queries/queries.models';
import { QueriesClientService } from '../services/queries/queries-client.services';
import * as Enumerable from "linq";
var ChartWidgetConfiguration = /** @class */ (function (_super) {
    __extends(ChartWidgetConfiguration, _super);
    function ChartWidgetConfiguration(entityTypeConfigurationHelper, queriesService) {
        var _this = _super.call(this, entityTypeConfigurationHelper) || this;
        _this.queriesService = queriesService;
        _this.aggrigationTypes = ["sum", "average", "count"];
        _this.color = "37ade7";
        return _this;
    }
    ChartWidgetConfiguration.prototype.entityTypeChanged = function () {
        var _this = this;
        this.queriesService.getNameProperties(this.entityTypeUri.replace(/ /g, ''))
            .then(function (nameProperties) {
            _this.nameProperties = [];
            _this.nameProperties.push({ name: "", friendlyName: " ", showByDefault: true, type: DataType.Default, format: "{0}", defaultOrdering: -1, isNullable: true, isDynamicProperty: true });
            _this.nameProperties = _this.nameProperties.concat(nameProperties);
            _this.aggrigationProperties = Enumerable.from(nameProperties).where(function (x) { return x.type == DataType.Number || x.type == DataType.Double; }).toArray();
            _this.aggrigationTypes = _this.aggrigationProperties.length > 0 ? ["sum", "average", "count"] : ["count"];
        });
        _super.prototype.entityTypeChanged.call(this);
    };
    ChartWidgetConfiguration.prototype.getModel = function (self) {
        var queryFilters = self.queryEditor.selectedFilters;
        var model = {
            columns: self.queryEditor.columns,
            queryFilters: queryFilters,
            title: self.title,
            color: self.color,
            entityTypeUri: self.entityTypeUri,
            nameProperty: self.nameProperty,
            aggrigationProperty: self.aggrigationProperty,
            aggrigationType: self.aggrigationType,
            selectedSavedQueryId: self._queryEditor.selectedSavedQuery ? self._queryEditor.selectedSavedQuery.queryId : -1
        };
        return model;
    };
    ChartWidgetConfiguration.prototype.setModelOverride = function (model) {
        this.title = model.title;
        this.nameProperty = model.nameProperty;
        this.color = model.color;
        this.aggrigationProperty = model.aggrigationProperty;
        this.aggrigationType = model.aggrigationType;
    };
    ChartWidgetConfiguration = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper, QueriesClientService])
    ], ChartWidgetConfiguration);
    return ChartWidgetConfiguration;
}(BaseQueryWidgetConfiguration));
export { ChartWidgetConfiguration };
